import { useEffect } from "react";
import { Link } from "react-router-dom";
import type { DirectoryPageContent } from "../content/types";

/**
 * Index page for a set of outcome pages. Its only job is to route, so it lists
 * every entry with the same blurb the mega-menu uses rather than inventing a
 * second description that can drift.
 */
export function DirectoryPage({ content }: { content: DirectoryPageContent }) {
  useEffect(() => {
    document.title = `${content.title} — Odingard`;
  }, [content.title]);

  return (
    <main className="page directory" id="main">
      <section className="pillar__hero">
        <p className="page__eyebrow">{content.eyebrow}</p>
        <h1>{content.headline}</h1>
        <p className="page__lede">{content.lede}</p>
      </section>

      <section className="pdp__section">
        <div className="home__cards">
          {content.entries.map((entry) => (
            <Link key={entry.href} to={entry.href} className="mm__card">
              <b>{entry.name}</b>
              <span className="mm__blurb">{entry.blurb}</span>
            </Link>
          ))}
        </div>
      </section>

      <section className="pdp__close">
        <h2>{content.close.heading}</h2>
        <p className="pdp__body">{content.close.body}</p>
        <div className="pdp__ctas">
          {content.close.ctas.map((cta, i) =>
            cta.external ? (
              <a
                key={cta.href}
                className={i === 0 ? "btn btn--primary" : "btn btn--quiet"}
                href={cta.href}
              >
                {cta.label}
              </a>
            ) : (
              <Link
                key={cta.href}
                className={i === 0 ? "btn btn--primary" : "btn btn--quiet"}
                to={cta.href}
              >
                {cta.label}
              </Link>
            ),
          )}
        </div>
      </section>
    </main>
  );
}
